var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.792 138.734h195.166v30h-195.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.792 198.734h195.166v30h-195.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.792 258.734h195.166v30h-195.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.126 301.741v-301.741h-272.715l-68.786 68.787v372.417h220.483c14.602 41.202 53.957 70.796 100.101 70.796 58.541 0 106.167-47.626 106.167-106.167-.001-51.382-36.693-94.351-85.25-104.092zm-262.767-269.262v46.256h-46.256zm-48.734 378.725v-302.47h78.734v-78.734h202.767v270.06c-54.304 4.624-97.084 50.293-97.084 105.773 0 1.801.046 3.592.135 5.371zm290.584 70.796c-41.999 0-76.167-34.168-76.167-76.167 0-41.998 34.168-76.166 76.167-76.166s76.167 34.168 76.167 76.166c-.001 41.999-34.169 76.167-76.167 76.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.497 407.62-11.971-11.971-21.213 21.213 33.184 33.184 56.607-56.607-21.213-21.212z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileComplete);
export default __webpack_public_path__ + "static/media/icon_file_complete.71a28342e81d2f7163a1d2eaeac2d437.svg";
export { ForwardRef as ReactComponent };